import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
	Theme,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import bluetooth from "../../../assets/icons/bluetooth.svg";
import buttonClose from "../../../assets/icons/buttonClose.svg";
import dinamo from "../../../assets/icons/Dinamo.svg";
import lightConnect from "../../../assets/icons/lightConnect.svg";
import lightSearch from "../../../assets/icons/lightSearch.svg";
import localization from "../../../assets/icons/localiozation.svg";
import { TextsProps } from "../../../database/txt.interface";
import { AppActions } from "../../../store/ducks/app";
import { Container } from "./styles";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0",
			boxShadow: theme.shadows[5],
		},
	})
);

const ModalConecta: React.FC = () => {
	const dispatch = useDispatch();

	const classes = useStyles();
	const is_open_conecta = useSelector(
		(state: any) => state.app.is_open_conecta
	);
	const current_language: TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);
	const ModalCadastroClose = () => {
		dispatch(AppActions.set_modal_conecta(false));
	};
	useEffect(()=>{
		dispatch(AppActions.set_modal_conecta3(false));
	},[])

	return (
		<div>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={is_open_conecta}
				onClose={ModalCadastroClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={is_open_conecta}>
					<Container>
						<img
							className="close"
							src={buttonClose}
							onClick={ModalCadastroClose}
							alt="Close"
						/>
						<img src={dinamo} alt="Dinamometro" />
						<div className="divText">
							<p className="text">{current_language?.modal_conecta}</p>
						</div>

						<div className="group">
							<div className="item">
								<img src={bluetooth} alt="bluetooth" />
								<p className="textSecundary">Bluetooth</p>
							</div>

							<div className="item">
								<img src={localization} alt="localização" />
								<p className="textSecundary">{current_language?.localizacao}</p>
							</div>
						</div>

						<div className="group">
							<div className="item">
								<img src={lightSearch} alt="Luz vermelha" />
								<p className="textSecundary">
									{current_language?.luz_piscando}
								</p>
							</div>

							<div className="item">
								<img src={lightConnect} alt="Luz verde" />
								<p className="textSecundary">
									{current_language?.luz_continua}
								</p>
							</div>
						</div>
					</Container>
				</Fade>
			</Modal>
		</div>
	);
};

export default ModalConecta;
